import './bootstrap';

// import { Calendar } from '@fullcalendar/core';
// import dayGridPlugin from '@fullcalendar/daygrid';
window.Calendar = require('@fullcalendar/core');
window.dayGridPlugin = require('@fullcalendar/daygrid');

window.Handsontable = require('handsontable').default;

window.ApexCharts = require('apexcharts');
window.moment = require('moment');
window.daterangepicker = require('daterangepicker'); // TODO, temporary
window.Pikaday = require('pikaday');

import './tabler';
import './demo';
import './tabler.esm';
import './demo-theme';
import './custom';
import './charts';
import './filters-kpi';
import './print';
